module.exports = __webpack_public_path__ + "atomic/organism/o-header/logo-print.png?v=338907";


//////////////////
// WEBPACK FOOTER
// ./Sig.Web/src/atomic/organism/o-header/logo-print.png
// module id = 153
// module chunks = 7